import GuideLayout from '@/components/Guides/GuideLayout';
export default function DocsLayout() { return <GuideLayout guideType="docs" />; }
